export const customSquareImages = {
  HOLLYBURN: 'https://publicyuhuassets.s3.ca-central-1.amazonaws.com/hollyburn_square.png',
};
